document.addEventListener('DOMContentLoaded', function () {
  var checkbox = document.getElementById('gift_wrap');
  if (!checkbox) return;

  function render(btn) {
    var checked = checkbox.checked;
    btn.classList.toggle('is-active', checked);
    btn.setAttribute('aria-pressed', checked);
    btn.querySelector('.gift-wrap-banner__toggle-text').textContent = checked ? 'Gift Wrapped' : 'Gift Wrap';
  }

  document.querySelectorAll('[data-gift-wrap-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    });

    checkbox.addEventListener('change', function () {
      render(btn);
    });

    render(btn);
  });
});
